const CELL_SIZE_BASE_PX = 10

const MAX_TRAIL_PIXELS = 48

export type GridPosition = {
  x: number
  y: number
}

export type GridDimensions = {
  cellSizePx: number
  height: number
  width: number
}

type RectLike = Pick<DOMRect, 'height' | 'left' | 'top' | 'width'>

export function getCellSizePx(wrapperWidth: number) {
  const cellCount = Math.ceil(wrapperWidth / CELL_SIZE_BASE_PX)
  const virtualCellSize = wrapperWidth / cellCount
  return wrapperWidth > 0 ? virtualCellSize : 0
}

export function areGridDimensionsEqual(current: GridDimensions, next: GridDimensions) {
  return current.cellSizePx === next.cellSizePx && current.height === next.height && current.width === next.width
}

export function getGridDimensions(width: number, height: number): GridDimensions {
  const cellSizePx = getCellSizePx(width)

  if (cellSizePx === 0) {
    return {cellSizePx, height: 0, width: 0}
  }

  return {
    cellSizePx,
    height: Math.ceil(Math.max(0, height) / cellSizePx),
    width: Math.ceil(Math.max(0, width) / CELL_SIZE_BASE_PX),
  }
}

export function getTrailGridPosition(
  clientX: number,
  clientY: number,
  rect: RectLike,
  gridWidth: number,
  gridHeight: number,
  cellSizePx: number,
): GridPosition | null {
  if (
    clientX < rect.left ||
    clientX >= rect.left + rect.width ||
    clientY < rect.top ||
    clientY >= rect.top + rect.height
  ) {
    return null
  }

  const gridLeft = rect.left + (rect.width - gridWidth * cellSizePx) / 2
  const gridTop = rect.top + (rect.height - gridHeight * cellSizePx) / 2
  const offsetX = clientX - gridLeft
  const offsetY = clientY - gridTop
  const x = Math.floor(offsetX / cellSizePx)
  const y = Math.floor(offsetY / cellSizePx)

  if (x < 0 || x >= gridWidth || y < 0 || y >= gridHeight) {
    return null
  }

  return {x, y}
}

export function shouldCreateTrailPixel(
  lastPosition: GridPosition | null,
  nextPosition: GridPosition,
  prefersReducedMotion: boolean,
  positionIsOccupied = false,
) {
  return (
    !prefersReducedMotion &&
    !positionIsOccupied &&
    (lastPosition?.x !== nextPosition.x || lastPosition?.y !== nextPosition.y)
  )
}

export function getEvictedTrailPixelIds(pixelIds: number[], maxPixels = MAX_TRAIL_PIXELS) {
  return pixelIds.slice(0, Math.max(0, pixelIds.length - maxPixels))
}
